import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import * as Stickyfill from 'stickyfilljs';
import get from 'lodash/get';
import Icon from './Icon';
import DownloadControls from './DownloadControls';
import { DataStore } from '../stores';
import { ShareClass } from '../models/entity';

const FundHeader = styled<any, any>('h1')`
    ${propStyles};
    top: ${p => `${p.stickyOffset || 0}px`};
    z-index: 1;
`;

FundHeader.defaultProps = {
    position: ['sticky', 'static'],
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'md',
    paddingX: 'md',
    paddingY: 'md',
    color: 'white',
    bgColor: 'secondary',
    borderWidth: '1px',
    borderColor: 'white',
    borderStyle: 'none none solid none',
};

const FundName = styled<any, any>('div')`
    ${propStyles};
`;

FundName.defaultProps = {
    marginX: 'sm',
};

const iconRightStyleProps = {
    order: 1,
    margin: '0 0 0 auto',
};

interface FundGroupHeaderProps {
    theme?: any;
    dataStore?: DataStore;
    shareClasses: Array<ShareClass>;
    fundName: string;
    rowType: string;
    expanded: boolean;
    toggleExpanded: () => void;
    downloadCount: number;
    documentDownloads: Array<string>;
}

@inject('dataStore')
@observer
class FundGroupHeader extends Component<FundGroupHeaderProps> {
    setStickyfill = element => {
        if (element) {
            Stickyfill.addOne(element);
        }
    };

    @computed
    get stickyOffset() {
        return this.props.dataStore.config.fundGroupHeader.stickyOffset;
    }

    @computed
    get expander() {
        return this.props.dataStore.config.fundGroupHeader.expander || {};
    }

    @computed
    get tile() {
        return this.props.dataStore.config.fundGroupHeader.tile;
    }

    @computed
    get headerExpandIconFilename() {
        const {
            expandIconFileName = 'HeaderChevronIconExpand',
            collapseIconFileName = 'HeaderChevronIconCollapse',
        } = this.expander;

        return this.props.expanded ? collapseIconFileName : expandIconFileName;
    }

    @computed
    get headerExpandable() {
        const {
            expandable = true,
        } = this.props.dataStore.config.fundGroupHeader;

        return expandable;
    }

    @computed
    get showExpanderIcon() {
        const { showIcon = true } = this.expander;

        return showIcon;
    }

    @computed
    get tileIconFilename() {
        const [firstShareClass] = this.props.shareClasses;
        const { property, propertyFilenameMap } = this.tile;
        const propertyValue = get(
            firstShareClass,
            `properties_pub.${property}.value`,
            ''
        );
        return propertyFilenameMap[propertyValue] || '';
    }

    @computed
    get hasDocumentDowloads() {
        return this.props.rowType === 'Documents';
    }

    render() {
        const {
            theme,
            dataStore,
            fundName,
            toggleExpanded,
            downloadCount,
            documentDownloads,
        } = this.props;
        return (
            <FundHeader
                stickyOffset={this.stickyOffset}
                innerRef={this.setStickyfill}
                onClick={this.headerExpandable ? toggleExpanded : undefined}
                cursor={this.headerExpandable ? 'pointer' : 'auto'}
                {...theme.FundHeader}
            >
                {this.headerExpandable && this.showExpanderIcon && (
                    <Icon
                        fileName={this.headerExpandIconFilename}
                        {...this.expander.align === 'right' &&
                            iconRightStyleProps}
                        iconSize="md"
                        {...theme.FundHeaderExpandIcon}
                    />
                )}
                {this.tile && (
                    <Icon
                        fileName={this.tileIconFilename}
                        {...this.tile.align === 'right' && iconRightStyleProps}
                        iconSize="md"
                        {...theme.FundHeaderTileIcon}
                    />
                )}
                <FundName {...theme.FundHeaderFundName}>{fundName}</FundName>
                {this.hasDocumentDowloads && (
                    <DownloadControls
                        label="Download"
                        margin="0 0 0 auto"
                        count={downloadCount}
                        disabled={downloadCount === 0}
                        onClick={e => {
                            e.stopPropagation();
                            dataStore.downloadDocuments(documentDownloads);
                        }}
                        downloadButtonFileName="HeaderDownloadIcon"
                        theme={{
                            ...theme,
                            ...{
                                DownloadControls:
                                    theme.FundHeaderDownloadControls,
                                DownloadButton: {
                                    fontSize: 'sm',
                                    ...theme.FundHeaderDownloadButton,
                                },
                                DownloadCount: theme.FundHeaderDownloadCount,
                            },
                        }}
                    />
                )}
            </FundHeader>
        );
    }
}

export default withTheme(FundGroupHeader);



// WEBPACK FOOTER //
// ./src/Components/FundGroupHeader.tsx